import React from 'react';

export function getMetadataTags({
  pageTitle,
  pageDescription,
  canonicalUrl,
  imageUrl,
  ogImageAlt,
  ogImageWidth = 2400,
  ogImageHeight = 1260,
}: {
  pageTitle: string;
  pageDescription: string;
  canonicalUrl: string;
  imageUrl: string;
  ogImageAlt?: string;
  /** Pixel size of the file imageUrl serves, when it differs from the 2400×1260 default. */
  ogImageWidth?: number;
  ogImageHeight?: number;
}) {
  return (
    <>
      <meta name='description' content={pageDescription} key='desc' />
      <link rel='canonical' href={canonicalUrl} key='canonical' />
      <meta property='og:locale' content='en_US' key='og:locale' />
      <meta property='og:site_name' content='Seed' key='og:site_name' />
      <meta property='og:title' content={pageTitle} key='og:title' />
      <meta property='og:description' content={pageDescription} key='og:desc' />
      <meta property='og:url' content={canonicalUrl} key='og:url' />
      <meta property='og:type' content='website' key='og:type' />
      <meta property='og:image' content={imageUrl} key='og:image' />
      <meta property='og:image:type' content='image/png' key='og:image:type' />
      <meta
        property='og:image:width'
        content={`${ogImageWidth}`}
        key='og:image:width'
      />
      <meta
        property='og:image:height'
        content={`${ogImageHeight}`}
        key='og:image:height'
      />
      <meta
        property='og:image:alt'
        content={ogImageAlt || pageTitle}
        key='og:image:alt'
      />
      <meta name='twitter:title' content={pageTitle} key='twitter:title' />
      <meta
        name='twitter:description'
        content={pageDescription}
        key='twitter:desc'
      />
      <meta name='twitter:url' content={canonicalUrl} key='twitter:url' />
      <meta
        name='twitter:card'
        content='summary_large_image'
        key='twitter:card'
      />
      <meta name='twitter:site' content='@seedhealth' key='twitter:site' />
      <meta name='twitter:image' content={imageUrl} key='twitter:image' />
      <meta
        name='twitter:image:alt'
        content={ogImageAlt || pageTitle}
        key='twitter:image:alt'
      />
    </>
  );
}
